module.exports = __webpack_public_path__ + "static/media/quick_icon.82f4d81d.svg";